export default {
  showHistoryDialog: false,
  sourceAddress: "",
  subject: "",
  content: "",
};
